import { installErrorBuffer } from "utils/errorBuffer";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "utils/http";

import "./index.css";
import App from "./App";
import { store } from "state";

// Keep the last few client errors for Help & feedback reports; must be first so nothing is missed.
installErrorBuffer();

// "ResizeObserver loop completed with undelivered notifications" is a benign browser quirk:
// Chrome emits it when an observer callback runs layout that spills into the next frame
// (our resizable sidebar + 3D-viewer observers trigger it when switching scenarios). It
// breaks nothing and production ignores it, but CRA's dev error-overlay client registers its
// own window 'error' listener before app code runs, so a stopImmediatePropagation handler
// can't intercept it. Fix it at the SOURCE instead: defer every ResizeObserver callback to
// the next animation frame, so the observation pass finishes before the callback mutates
// layout — the loop-notification error is never thrown. (Standard, widely-used workaround.)
if (typeof window !== "undefined" && typeof window.ResizeObserver === "function") {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
